import { BasicBooking_livestockType } from '../graphql/fragments/gql/BasicBooking';

export const resolveLivestockTypeText = (
  livestockType: BasicBooking_livestockType | null,
): string => {
  return livestockType?.label ?? 'No';
};
